/**
 * Pricing Hero Animation Logic
 */

document.addEventListener("DOMContentLoaded", () => {
	// Ensure GSAP is loaded
	if (typeof gsap === "undefined") {
		console.warn("GSAP not found. Pricing Hero animation skipped.");
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const sections = document.querySelectorAll('.osmerova-pricing-hero[data-gsap="pricing-hero"]');

	sections.forEach((section) => {
		let ctx = gsap.context(() => {
			
			// 1. Parallax Background
			const bgImage = section.querySelector('.osmerova-pricing-bg img');
			if (bgImage) {
				gsap.to(bgImage, {
					yPercent: -20,
					ease: "none",
					scrollTrigger: {
						trigger: section,
						scrub: true,
						start: "top bottom", // Start when section enters viewport
						end: "bottom top" // End when section leaves viewport
					}
				});
			}

			// 2. Card Reveal
			const card = section.querySelector('.osmerova-pricing-card');
			if (card) {
				gsap.from(card, {
					y: 100,
					opacity: 0,
					duration: 1,
					ease: "power2.out",
					scrollTrigger: {
						trigger: section,
						start: "top 60%", // Start when top of section is at 60% of viewport height
						// markers: true
					}
				});
			}

		}, section);
	});
});
